




import { Component, Vue, Watch } from 'vue-property-decorator';
import { MutationMethod } from 'vuex';
import { Mutation, State } from 'vuex-class';
import Place from "@/models/place";

@Component({})
export default class App extends Vue {
  @State('isSocketConnected')
  private isSocketConnected!: boolean;

  @State('selectedPlace', {
    namespace: 'place',
  })
  private selectedPlace!: Place;

  @Watch('selectedPlace')
  private async onSelectedPlaceChanged(place: Place | null, oldPlace: Place | null) {
    if (this.isSocketConnected) {
      this.connectToNewSocketRoom(place && place.token, oldPlace && oldPlace.token);
      this.connectToNewSocketRoom(place && place.projectId, oldPlace && oldPlace.projectId);
    }
  }

  @Watch('isSocketConnected', {
    immediate: true,
  })
  private onIsSocketConnectedChanged(isSocketConnected: boolean) {
    if (isSocketConnected && this.selectedPlace) {
      this.connectToNewSocketRoom(this.selectedPlace.token, null);
      this.connectToNewSocketRoom(this.selectedPlace.projectId, null);
    }
  }

  private created() {
    if (process.env.NODE_ENV === 'production') {
      document.body.addEventListener('contextmenu', (event) => {
        event.preventDefault();
      });
    }

    this.saveBeforeInstallPromptEvent();
  }

  private connectToNewSocketRoom(placeToken: string | null, oldPlaceToken: string | null) {
    if (oldPlaceToken !== null) {
      this.$socket.emit('leave', oldPlaceToken);
    }

    if (placeToken !== null) {
      this.$socket.emit('join', placeToken);
    }
  }

  private saveBeforeInstallPromptEvent() {
    window.addEventListener('beforeinstallprompt', (beforeInstallPromptEvent) => {
      beforeInstallPromptEvent.preventDefault();

      this.setBeforeInstallPromptEvent(beforeInstallPromptEvent);
    });
  }

  @Mutation('setBeforeInstallPromptEvent')
  setBeforeInstallPromptEvent!: MutationMethod;
}
